import React, { useMemo } from 'react';
import { GenericChartLoading } from 'src/components/common/Loading/PlaceHolderLoading/PlaceHolderLoading';
import { useAppSelector } from 'src/utils/Hooks';
import { withBus } from 'react-bus';
import Visualization from 'src/components/Layout/Advertising/ConnectPageLayout/components/Visualization';
import useAmcDateRange from 'src/components/Layout/Advertising/ConnectPageLayout/visualizations/hooks/useAmcDateRange';
import _get from 'lodash/get';
import useGenericAdvancedSearch from 'src/utils/Hooks/useGenericAdvancedSearch';
import BrandedSearchRateByCampaignBarChart from 'src/components/Layout/Advertising/ConnectPageLayout/visualizations/AudiencesTab/BrandedSearchRateByCampaign/BrandedSearchRateByCampaignBarChart';
import {
  brandedSearchRateByCampaignAdvancedSearchParser,
  buildRequestForBrandedSearchRateByCampaign
} from 'src/components/Layout/Advertising/ConnectPageLayout/visualizations/AudiencesTab/BrandedSearchRateByCampaign/utils';
import { BrandedSearchRateByCampaignData } from 'src/components/Layout/Advertising/ConnectPageLayout/visualizations/AudiencesTab/BrandedSearchRateByCampaign/types';

const BrandedSearchRateByCampaignVisualization = () => {
  const { startDayId, endDayId } = useAmcDateRange();
  const { retailer } = useAppSelector((state) => state);

  // Advanced Search Request Body
  const brandedSearchRateByCampaignRequestBody = useMemo(
    () => buildRequestForBrandedSearchRateByCampaign({ startDayId, endDayId, retailerId: retailer.id }),
    [endDayId, startDayId, retailer.id]
  );

  // Fetching data
  /**
   * We avoid using fetchEntityMetrics because it will mutate our request overrides
   */
  const { data, isLoading } = useGenericAdvancedSearch({
    requestBody: brandedSearchRateByCampaignRequestBody,
    queryKeys: brandedSearchRateByCampaignRequestBody,
    requestId: 'branded-search-rate-by-campaign'
  });

  // Data Access and formatting
  const chartData = useMemo(() => {
    if (data) {
      const documentData = brandedSearchRateByCampaignAdvancedSearchParser(_get(data, 'data[0]'));

      const filteredDocuments = documentData.filter((document: BrandedSearchRateByCampaignData) => {
        return document.additionalValues.impressions_sum_value > 0;
      });

      const tuples = [];

      filteredDocuments.forEach((document) => {
        const numeratorValue = document.additionalValues.numberOfBrandedSearches_sum_value;
        const denominatorValue = document.additionalValues.impressions_sum_value;
        const campaignName = document.additionalMetaData['campaign.keyword'];
        const ratio = denominatorValue > 0 ? (numeratorValue / denominatorValue) * 100 : 0;
        tuples.push([campaignName, ratio]);
      });

      tuples.sort((a, b) => b[1] - a[1]);

      return { chartData: tuples };
    }
    return null;
  }, [data]);

  return (
    <Visualization
      titleProps={{
        title: ''
      }}
    >
      <div style={{ marginTop: '24px' }}>
        {isLoading && <GenericChartLoading />}
        {!isLoading && chartData && <BrandedSearchRateByCampaignBarChart data={chartData.chartData} />}
      </div>
    </Visualization>
  );
};

export default withBus('eventBus')(BrandedSearchRateByCampaignVisualization);
